import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppContext } from '../../context/AppContext';
import InverterConnectedMessage from '../../ui/InverterConnectedMessage';

const ConnectedContainer = () => {
  const { subscriptionsDisabled } = useContext(AppContext);
  const [next, setNext] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (subscriptionsDisabled) {
      setNext('/onboarding/finalising');
    } else {
      setNext('/onboarding/subscription');
    }
  }, []);

  return <InverterConnectedMessage onContinue={() => navigate(next)} />;
};

export default ConnectedContainer;
